<template>
  <div>
    <div class="pic-404-body">
      <div class="pic-404">
        <img
          :src="noFoundImg"
          class="pic-404__parent"
        />
        <img
          :src="cloundImg"
          class="pic-404__child left"
        />
        <img
          :src="cloundImg"
          class="pic-404__child mid"
        />
        <img
          :src="cloundImg"
          class="pic-404__child right"
        />
      </div>
      <div class="bullshit">
        <p class="bullshit__oops">404错误!</p>
        <p class="bullshit__headline">找不到网页！</p>
        <p class="bullshit__info">
          对不起，您正在寻找的页面不存在。尝试检查URL是否错误，
          然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。
        </p>
        <p
          class="bullshit__return-home"
          v-if="goHomeFlag"
        >
          <el-button
            type="primary"
            round
            @click="goHome"
          >返回首页 </el-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import auth from "../scripts/auth";

export default {
  name: "no-found",
  props: {
    defaultPath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      noFoundImg: require("../assets/images/404.png"),
      cloundImg: require("../assets/images/404_cloud.png"),
      goHomeFlag: false,
    };
  },
  created() {},
  methods: {
    goHome() {
      this.$emit("goHome")
      // if (auth.getToken()) {
      //   this.$router.push({ path: "/" });
      // } else {
      //   auth.loginOut();
      // }
    },
  },
};
</script>
<style scoped>
.pic-404 {
  position: relative;
  width: 600px;
  overflow: hidden;
}

.pic-404__parent {
  width: 100%;
  height: auto;
}

.pic-404-body {
  position: relative;
  width: 1200px;
  padding: 0 50px;
  overflow: hidden;
  margin: 10vh auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bullshit {
  position: relative;
  /* float: left; */
  width: 300px;
  padding: 30px 0;
  overflow: hidden;
}

.bullshit__oops {
  font-size: 32px;
  line-height: 40px;
  color: #1482f0;
  margin-bottom: 20px;
  animation-fill-mode: forwards;
}

.bullshit__headline {
  font-size: 20px;
  line-height: 24px;
  color: #222;
  margin-bottom: 10px;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
}

.bullshit__oops,
.bullshit__headline {
  font-weight: 700;
  opacity: 0;
  animation-name: slideUp;
  animation-duration: 0.5s;
}

.bullshit__info,
.bullshit__return-home {
  opacity: 0;
  animation-name: slideUp;
  animation-duration: 0.5s;
}

.bullshit__info {
  font-size: 13px;
  line-height: 21px;
  color: grey;
  margin-bottom: 30px;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}

.bullshit__return-home {
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

@keyframes slideUp {
  0% {
    /* -webkit-transform: translateY(60px); */
    transform: translateY(60px);
    opacity: 0;
  }
  100% {
    /* -webkit-transform: translateY(0); */
    transform: translateY(0);
    opacity: 1;
  }
}

.pic-404__child {
  position: absolute;
}

.pic-404__child.left {
  width: 80px;
  top: 17px;
  left: 220px;
  opacity: 0;
  animation-name: cloudLeft;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}

@keyframes cloudLeft {
  0% {
    top: 17px;
    left: 220px;
    opacity: 0;
  }
  20% {
    top: 33px;
    left: 188px;
    opacity: 1;
  }
  80% {
    top: 81px;
    left: 92px;
    opacity: 1;
  }
  100% {
    top: 97px;
    left: 60px;
    opacity: 0;
  }
}

.pic-404__child.mid {
  width: 46px;
  top: 10px;
  left: 420px;
  opacity: 0;
  animation-name: cloudMid;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1.2s;
}

@keyframes cloudMid {
  0% {
    top: 10px;
    left: 420px;
    opacity: 0;
  }
  20% {
    top: 40px;
    left: 360px;
    opacity: 1;
  }
  70% {
    top: 130px;
    left: 180px;
    opacity: 1;
  }
  100% {
    top: 160px;
    left: 120px;
    opacity: 0;
  }
}

.pic-404__child.right {
  width: 62px;
  top: 100px;
  left: 500px;
  opacity: 0;
  animation-name: cloudRight;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}

@keyframes cloudRight {
  0% {
    top: 100px;
    left: 500px;
    opacity: 0;
  }
  20% {
    top: 120px;
    left: 460px;
    opacity: 1;
  }
  80% {
    top: 180px;
    left: 340px;
    opacity: 1;
  }
  100% {
    top: 200px;
    left: 300px;
    opacity: 0;
  }
}
</style>
